import { Link } from 'react-router-dom';
import type { comics as ComicsType } from '@/mocks/comics';

type Comic = (typeof ComicsType)[number];

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[130px] h-[173px]',
    medium: 'w-[160px] h-[213px]',
    large: 'w-[200px] h-[267px]',
  };

  return (
    <Link
      to={`/comic/${comic.slug}`}
      className="group block no-underline"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`${coverSizes[size]} relative overflow-hidden rounded-lg bg-background-100 flex-shrink-0`}>
        <img
          src={comic.cover}
          alt={`${comic.title} - 香香漫画免费在线阅读`}
          title={`${comic.title} | 香香漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 bg-foreground-950/70 text-background-50 text-xs px-2 py-0.5 rounded">
            已完结
          </span>
        )}
        {comic.isHot && (
          <span className="absolute top-2 right-2 bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded">
            热门
          </span>
        )}
        {comic.isNew && !comic.isHot && (
          <span className="absolute top-2 right-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded">
            新作
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/70 to-transparent h-16 flex items-end p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-background-50 text-xs line-clamp-2">{comic.description}</p>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 mt-0.5">{comic.author}</p>
        {size !== 'small' && (
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-foreground-500">
              <i className="ri-eye-line mr-0.5 w-3 h-3 inline-flex items-center justify-center"></i>
              {(comic.views / 10000).toFixed(0)}万
            </span>
            <span className="text-xs text-foreground-500">
              <i className="ri-star-fill text-accent-500 mr-0.5 w-3 h-3 inline-flex items-center justify-center"></i>
              {comic.rating}
            </span>
          </div>
        )}
      </div>
    </Link>
  );
}